import {Injectable} from '@angular/core';
import {BasicService} from '../../services/basic.service';

@Injectable({
  providedIn: 'root',
})
export class CommonCommponentsService extends BasicService {
  getSystemTableSetting(name) {
    return this.get({
      url: `${this.apiUrl}/api/app/systemTableMade/querySysTemTableCache`,
      params: {
        pageCode: name,
      },
    });
  }

  updateSystemTableSetting(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/systemTableMade/updateSysTableMade`,
      body: {
        ...value,
      },
    });
  }
}
